import React, { FC } from 'react';
import { Text, View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { font } from '@styles/fonts';
import { SimpleOnPress } from '@interfaces/base';
import { DashboardScope, type CustomerDashboardResult } from '@api/domain/types';

import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import type { Rank, RankBadgeVariant, WithBorderRadiusConfig } from '@v2/pages/dashboard/common/types/rows';
import DashboardOverviewBottomBlockRowBadge from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewBottomBlock/components/DashboardOverviewBottomBlockPanel/components/DashboardOverviewBottomBlockRowBadge';
import DashboardOverviewBottomBlockRowValue from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewBottomBlock/components/DashboardOverviewBottomBlockPanel/components/DashboardOverviewBottomBlockRowValue';
import DashboardRowWrapper from '@v2/pages/dashboard/common/components/DashboardRowWrapper';

interface DashboardOverviewBottomBlockCustomerRowProps
  extends WithColor,
    SimpleOnPress,
    WithBorderRadiusConfig,
    Pick<CustomerDashboardResult, 'customerName' | 'customerId' | 'totalTimeTotalInSeconds'> {
  rank: Rank;
  variant: RankBadgeVariant;
}

const DashboardOverviewBottomBlockCustomerRow: FC<DashboardOverviewBottomBlockCustomerRowProps> = ({
  C,
  rank,
  variant,
  customerName,
  totalTimeTotalInSeconds,
  onPress,
  borderRadiusConfig,
}) => (
  <DashboardRowWrapper onPress={onPress} testID={TEST_IDS.dashboardOverviewBottomBlock.row(variant, rank)} scope={DashboardScope.Customer} borderRadiusConfig={borderRadiusConfig}>
    <DashboardOverviewBottomBlockRowBadge rank={rank} variant={variant} />
    <View style={{ flex: 1 }}>
      <Text style={[font['Subhead 1 bold'], { color: C('Label/Light/Primary') }]} numberOfLines={1}>
        {customerName ?? ''}
      </Text>
    </View>
    <DashboardOverviewBottomBlockRowValue seconds={totalTimeTotalInSeconds ?? 0} variant={variant} />
  </DashboardRowWrapper>
);

export default ColorWrapper(DashboardOverviewBottomBlockCustomerRow);
